module.exports = __webpack_public_path__ + "img/10882_L.2737c8b7.png";